var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "widget" }, [
    _c(
      "div",
      { staticClass: "tabs-left" },
      [
        _c("ul", { staticClass: "nav nav-tabs", attrs: { role: "tablist" } }, [
          _c(
            "li",
            {
              staticClass: "nav-item",
              class: { active: _vm.activeName == "first" },
              attrs: { role: "presentation" },
            },
            [
              _c(
                "span",
                {
                  staticClass: "nav-link",
                  attrs: { role: "tab", "data-toggle": "tab" },
                  on: {
                    click: function ($event) {
                      _vm.activeName = "first"
                    },
                  },
                },
                [
                  _c("img", {
                    staticClass: "dashboard-icons",
                    attrs: {
                      src: "/static/images/icons/submission_icon_blue.svg",
                    },
                  }),
                  _vm._v(" Project Status "),
                ]
              ),
            ]
          ),
          _c(
            "li",
            {
              staticClass: "nav-item",
              class: { active: _vm.activeName == "second" },
              attrs: { role: "presentation" },
            },
            [
              _c(
                "span",
                {
                  staticClass: "nav-link",
                  attrs: { role: "tab", "data-toggle": "tab" },
                  on: {
                    click: function ($event) {
                      _vm.activeName = "second"
                    },
                  },
                },
                [
                  _c("img", {
                    staticClass: "dashboard-icons",
                    attrs: {
                      src: "/static/images/icons/submission_icon_blue.svg",
                    },
                  }),
                  _vm._v(" Project Type "),
                ]
              ),
            ]
          ),
        ]),
        _vm.activeName == "first"
          ? _c("pie-chart", { attrs: { isCombo: true, sbData: _vm.sbData } })
          : _vm._e(),
        _vm.activeName == "second"
          ? _c("project-type", {
              attrs: { Initialtitle: "", sbData: _vm.sbData },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }